/**
 *功能: 微信接口
 */
export default {
  $getway: 'OurwayWechat',
  sendSMSCode: 'wregister/sendSMSCode', // 验证短信发送
};
